import { Base64 } from 'js-base64';

const encoder = (locationObject) => {
  try {
    const pLocationString = JSON.stringify(locationObject);

    return Base64.encode(pLocationString);
  } catch (error) {
    console.log('Error while encoding location to base64: ', error);

    return null;
  }
};

export default (preparedSearchParams, data) => {
  const { isTest, ...routerParams } = preparedSearchParams;
  const { pickUp, dropOff } = data;

  routerParams.pLocation = encoder(pickUp);
  if (dropOff) {
    routerParams.dLocation = encoder(dropOff);
  }
  if (isTest) {
    routerParams.isTest = isTest;
  }

  return routerParams;
};
